import { DotLegalButton, DotLegalDeleteDialog, DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../../localization/useTranslation";
import { Box } from "@mui/material";
import InternalAssessmentTable from "../../../../common/components/questionnaireComponents/internalAssessmentTable/InternalAssessmentTable";
import NoSharings from "../../../../processingActivity/processingActivityOverview/processingActivitySharingsTab/noSharings.svg?react";
import useSystemInternalAssessmentTabHooks from "./SystemInternalAssessment.hooks";
import SystemInternalAssessmentDialog from "./systemInternalAssessmentDialog/SystemInternalAssessmentDialog";
import { useUserContext } from "../../../../auth/userContextProvider/UserContextProvider";

export interface ISystemInternalAssessmentTabProps {
    systemId: string;
    systemName: string;
}

function SystemInternalAssessmentTab(props: ISystemInternalAssessmentTabProps) {
    const { translateString } = useTranslation();
    const { permissions } = useUserContext();
    const {
        showAddDialog,
        setShowAddDialog,
        data,
        isLoading,
        refetch,
        setShowDeleteDialog,
        showDeleteDialog,
        setSelectedInternalAssessment,
        removeAssociatedInternalAssessment,
        isRemoving,
    } = useSystemInternalAssessmentTabHooks(props);

    return (
        <>
            <InternalAssessmentTable
                internalAssessmentModel={data}
                isLoading={isLoading}
                readOnly
                emptyState={<DotLegalEmptyState icon={<NoSharings />} text={translateString("noAssociatedInternalAssessments")} />}
                getMenuItems={(row) =>
                    permissions.systemPermissions.edit
                        ? [
                              {
                                  menuItem: translateString("removeAssociation"),
                                  onClick: () => {
                                      setSelectedInternalAssessment(row);
                                      setShowDeleteDialog(true);
                                  },
                              },
                          ]
                        : []
                }
                sessionStorageKey={`system-${props.systemId}-internal-assessments-filters`}
            />

            {permissions.systemPermissions.edit && (
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <DotLegalButton onClick={() => setShowAddDialog(true)} buttonType={"primary"}>
                        {translateString("associateAssessmentToSystem")}
                    </DotLegalButton>
                </Box>
            )}

            {showAddDialog && (
                <SystemInternalAssessmentDialog
                    systemName={props.systemName}
                    systemId={props.systemId}
                    onDialogClose={() => {
                        refetch();
                        setShowAddDialog(false);
                    }}
                    existingInternalAssessments={data ? data?.rows?.map((x) => x.id) : []}
                />
            )}

            {showDeleteDialog && (
                <DotLegalDeleteDialog
                    open
                    headerText={translateString("removeAssociation")}
                    warningTranslation={""}
                    deleteBtnText={translateString("remove")}
                    cancelBtnText={translateString("cancel")}
                    onDialogClose={() => setShowDeleteDialog(false)}
                    onOkClick={() => removeAssociatedInternalAssessment()}
                    alertBodyText={translateString("removeInternalAssessmentToSystem")}
                    inProgress={isRemoving}
                />
            )}
        </>
    );
}

export default SystemInternalAssessmentTab;
